// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {glofun} from "./util/util"
import axios from 'axios'
import './util/directive'
import './ajax/defaultsetting'
import VueI18n from "vue-i18n"
import {GA} from "@/util/GA"
import jquery from "jquery"
import "./util/jump"
import messages from "./language/en"
import userstore from "./store/user"
import homepage from "./store/homepage"
import tips from "./components/glocompoen/tips"
import asyAddEle from "./util/asy_add_ele"
import VueScroller from 'vue-scroller'
import SocialSharing from "../static/vue-social-sharing/"
import rotate from "./util/rotate"
rotate();
Vue.use(SocialSharing);
Vue.use(VueScroller);
Vue.component('tips',tips);
Vue.use(VueI18n);
Vue.prototype.router = router;
const i18n = new VueI18n({
locale: 'en', // set locale
  messages:messages, // set locale messages
});
new Vue({ i18n }).$mount('#app');
Vue.prototype.$glofun=glofun;
Vue.prototype.$http=axios;
Vue.prototype.$jquery=jquery;
Vue.prototype.$asyAddEle=asyAddEle;
router.beforeEach((to,from,next)=>{
  userstore.state.shows=false;
  homepage.state.isshare=true;
  homepage.state.showoption=false;
  next();
});
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n
});




// WEBPACK FOOTER //
// ./src/main.js